import React from "react";
import { cn } from "../../lib/utils";

export const Button = ({ children, isActive, langMode, ...props }) => {
    return (
        <button
            type="button"
            className={cn(
                "inline-flex items-center justify-center gap-2 rounded-lg border border-transparent px-4 text-sm font-semibold transition-colors duration-200",
                "min-h-[36px] h-9 py-0 box-border",
                "whitespace-nowrap",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
                "bg-gray-200 text-gray-700 shadow-sm hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600",
                isActive && "bg-[#236DB4] text-white shadow-md hover:bg-blue-[#236DB4] dark:bg-blue-[#236DB4] dark:hover:bg-blue-[#236DB4]"
            )}
            {...props}
        >
            {children}
        </button>
    );
};